import { NgModule } from '@angular/core';
import {
  NoPreloading,
  RouterModule,
  Routes,
  UrlSegment,
} from '@angular/router';
import { CustomUrlGuard } from './core/guards/custom-url.guard';
import { PermissionsGuard } from './core/guards/permissions.guard';
import { slugPageExistsGuard } from './core/guards/slug-page-exists.guard';

const routes: Routes = [
  {
    matcher: (url) => {
      if (!['it', 'en'].includes(url[0]?.path)) {
        return {
          consumed: url,
          posParams: {
            lang: new UrlSegment('it', {}),
          },
        };
      }
      return null;
    },
    loadComponent: () =>
      import('./lang-url/components/load-url/load-url.component').then(
        (m) => m.LoadLangUrlComponent
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [PermissionsGuard],
    canActivateChild: [PermissionsGuard],
    data: {
      expectedIdProfile: [1],
    },
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
    canActivate: [PermissionsGuard],
    canActivateChild: [PermissionsGuard],
    data: {
      expectedIdProfile: [1, 2, 3, 4],
    },
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'auction/:idAuction',
    loadComponent: () =>
      import('./article/article.component').then((m) => m.ArticleComponent),
  },
  {
    path: 'event',
    loadChildren: () =>
      import('./event/event-routing.module').then((m) => m.EventRoutingModule),
  },
  {
    path: 'eventnow',
    loadChildren: () =>
      import('./event-now/event-now.module').then((m) => m.EventNowModule),
  },
  {
    path: 'campaign/:idCampaign',
    loadComponent: () =>
      import('./campaign/campaign.component').then((m) => m.CampaignComponent),
  },
  {
    path: 'promoter/:idPromoter',
    loadComponent: () =>
      import('./promoter/promoter.component').then((m) => m.PromoterComponent),
  },
  {
    path: 'tags/:tag',
    loadComponent: () =>
      import('./tags-page/tags-page.component').then(
        (m) => m.TagsPageComponent
      ),
  },
  {
    path: 'certificate/:certificateCode',
    loadComponent: () =>
      import('./certificate/certificate.component').then(
        (m) => m.CertificateComponent
      ),
  },
  {
    path: 'search-result',
    loadComponent: () =>
      import('./search-result/search-result.component').then(
        (m) => m.SearchResultComponent
      ),
  },
  {
    path: 'search-result-all',
    loadComponent: () =>
      import('./search-result/search-result.component').then(
        (m) => m.SearchResultComponent
      ),
  },
  {
    path: 'search-result-worn',
    loadComponent: () =>
      import('./search-result/search-result.component').then(
        (m) => m.SearchResultComponent
      ),
  },
  {
    path: 'search-result-store',
    loadComponent: () =>
      import('./search-result/search-result.component').then(
        (m) => m.SearchResultComponent
      ),
  },
  {
    path: 'search-result-signed',
    loadComponent: () =>
      import('./search-result/search-result.component').then(
        (m) => m.SearchResultComponent
      ),
  },

  {
    path: 'stripe',
    loadChildren: () =>
      import('./stripe/stripe.module').then((s) => s.StripeModule),
  },
  {
    path: 'seller/:id',
    loadComponent: () =>
      import('./seller/pages/seller/seller.component').then(
        (s) => s.SellerComponent
      ),
  },
  {
    // Dynamic generic page slug (must precede customUrl matcher). If slug not found guard returns false and routing continues.
    path: ':slug',
    canMatch: [slugPageExistsGuard],
    loadComponent: () =>
      import('./generic-page/generic-page.component').then(
        (m) => m.GenericPageComponent
      ),
  },
  {
    matcher: (url) => {
      if (url.length > 0) {
        let urlPath: string = '';
        url.forEach((segment) => {
          urlPath += `/${segment.path}`;
        });
        return {
          consumed: url,
          posParams: {
            customUrl: new UrlSegment(urlPath, {}),
          },
        };
      }
      return null;
    },
    loadComponent: () =>
      import('./custom-url/components/load-url/load-url.component').then(
        (m) => m.LoadUrlComponent
      ),
    canMatch: [CustomUrlGuard],
  },
  { path: '**', redirectTo: 'home' },
].flatMap((route) => {
  const r1 = { ...route };
  if (r1.path) {
    r1.path = `:lang/${r1.path}`;
    return [r1, route];
  }
  return [route];
});

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledBlocking',
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
